// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__TPVgL","label":"Completed_label__3aV-i"};